import { format, isValid, parseISO } from 'date-fns';

/** Parses a DB date ('YYYY-MM-DD', with or without time); null when empty or a zero-date. */
export const parseDbDate = (raw: string | undefined): Date | null => {
  if (!raw) return null;
  const d = parseISO(raw.replace(' ', 'T'));
  // The DB zero-dates (0001-01-01 / 0000-00-00) parse as "valid", so floor at 1900.
  return isValid(d) && d.getFullYear() >= 1900 ? d : null;
};

/** True when a DB date is a real calendar date rather than empty or a zero-date. */
export const isRealDate = (raw: string | undefined): boolean => parseDbDate(raw) !== null;

export const formatMembershipDate = (raw: string | undefined): string => {
  const d = parseDbDate(raw);
  return d ? format(d, 'MMM d, yyyy') : '—';
};
